module.exports = __webpack_public_path__ + "media/15-2.a7c9f0e4.mp4";